module.exports = __webpack_public_path__ + "static/media/baggage.f1227898.jpg";